export default __webpack_public_path__ + "static/media/AutomationDelay.ba226df8.svg";